module.exports = __webpack_public_path__ + "static/media/IN_Payslip_3.a7080f9e.png";